import { gql } from "@apollo/client";

export const CREATE_ANNOUNCEMENT = gql`
  mutation CreateAnnouncement($input: NotificationLedgerInput!) {
    createAnnouncement(input: $input) {
      _id
      title
      body
      image
      isSticky
      type
      expiresAt
      createdAt
      masjids {
        _id
        masjidName
      }
      status
    }
  }
`;

export const VERIFY_AND_SEND_ANNOUNCEMENT = gql`
  mutation VerifyAndSendAnnouncement($otp: String!) {
    verifyAndSendAnnouncement(otp: $otp) {
      _id
      title
      body
      image
      isSticky
      type
      expiresAt
      createdAt
      masjids {
        _id
        masjidName
      }
      status
    }
  }
`;
